import script from "./LiturgiesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LiturgiesTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__